// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"432":"48fc3634","557":"bbeeeea3","779":"83e66b44","867":"e5422fcc","880":"503533dd","956":"16da0c65"}[chunkId] + ".chunk.css";
};